export function set(accounts, path, value) {
    if (!value) {
        return accounts;
    }
    let curr = accounts;
    path.forEach((p, idx) => {
        const isLast = idx == path.length - 1;
        if (isLast) {
            curr[p] = value;
        }
        curr[p] = curr[p] || {};
        curr = curr[p];
    });
    return accounts;
}
export function get(accounts, path) {
    // Only return if pubkey
    const ret = path.reduce((acc, subPath) => {
        if (acc) {
            return acc[subPath];
        }
    }, accounts);
    if (ret && ret.toBase58) {
        return ret;
    }
}
//# sourceMappingURL=utils.js.map